function checkButton(instances) {
    const allDisabled = Array.from(instances).every((i) => {
        return i.disabled;
    });

    if (allDisabled) {
        const button = document.querySelector('.js-book-button');

        if (button) {
            button.disabled = true;
        }
    }
}
function instanceAvailability(instances) {
    if (!instances.length) {
        return;
    }

    instances.forEach(instance => {
        if (instance.hasAttribute('data-js-parsed--instance-availability')) {
            return;
        }

        instance.setAttribute(`data-js-parsed--instance-availability`, '');

        const { id } = instance.dataset;

        if (id) {
            fetch(`/Umbraco/Api/Availability/GetAvailability?instanceId=${id}`, {
                method: 'POST',
            })
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.capacity > 0 && data.available === 0) {
                            instance.classList.add('instance-unavailable');
                            instance.disabled = true;

                            if (instance.type === 'radio') {
                                instance.checked = false;

                                const label = instance.nextElementSibling;

                                if (label) {
                                    label.innerHTML = label.innerHTML + '<span>- SOLD OUT</span>'
                                }
                            }
                            else {
                                instance.innerHTML = instance.innerHTML + '<span>- SOLD OUT</span>'
                            }

                            checkButton(instances);
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        }
    });
}

export default instanceAvailability;
